const extractPlainText = (htmlContent) => {
  if (!htmlContent) return "";

  // Try DOM parsing first (handles &nbsp; and other HTML entities better).
  try {
    if (typeof window !== "undefined" && typeof DOMParser !== "undefined") {
      const doc = new DOMParser().parseFromString(String(htmlContent), "text/html");
      return (doc.body?.textContent || "")
        .replace(/\s+/g, " ")
        .replace(/\u00A0/g, " ")
        .trim();
    }
  } catch {
    // Fallback to regex below
  }

  // Fallback: strip tags and normalize whitespace.
  return String(htmlContent)
    .replace(/&nbsp;/g, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

export const countWordsInHtml = (htmlContent) => {
  const text = extractPlainText(htmlContent);
  if (!text) return 0;
  return text.split(/\s+/).filter(Boolean).length;
};

export const calculateReadingTime = (htmlContent) => {
  const words = countWordsInHtml(htmlContent);
  // Keep consistent with RichTextEditor (~200 words/minute)
  const minutes = Math.ceil(words / 200);
  return Math.max(1, minutes || 1);
};

export { extractPlainText };
